import { SingleLineAddressOnListing } from '@/components/Address'
import { capitalize } from '@/utils/strings'

export default ({ bien }) => {
  const handleCardClick = (bienId) => {
    window.location.href = `/extranet/locataire/biens/${bienId}`
  }

  const formatPrice = (price) => {
    return price ? `${price.toLocaleString('fr-FR')} €` : '-'
  }

  return (
    <div 
      className="card bg-primary-200 w-full md:w-[calc(50%-0.5rem)] cursor-pointer hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 border-2 border-primary-300 hover:border-primary-500"
      onClick={() => handleCardClick(bien.id)}
    >
      <div className="card-body p-4 bg-base-200 relative">
        {/* Indicateur visuel de clic */}
        <div className="absolute top-2 right-2 text-primary-500">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
        <div className="grid grid-cols-2 gap-2">

          <div className="text-sm font-medium text-gray-600">Type</div>
          <div>{capitalize(bien.type_bien)}</div>

          <div className="text-sm font-medium text-gray-600">Loyer</div>
          <div>{formatPrice(bien.location?.prix_loyer)}</div>

          <div className="text-sm font-medium text-gray-600">Charges</div>
          <div>{formatPrice(bien.location?.montant_charges_total)}</div>

          <div className="text-sm font-medium text-gray-600">Adresse</div>
          <div>
            <SingleLineAddressOnListing data={bien} withCodePostal={true} />
          </div>

          <div className="text-sm font-medium text-gray-600">Surface</div>
          <div>{bien.surface_carrez ? `${bien.surface_carrez} m²` : '-'}</div>

        </div>
      </div>
    </div>
  )
}
